import React from 'react';
import {
  useGetDVValidatorQuery,
  useGetModuleCalcQuery,
  useGetModuleTelegramQuery,
  useLazyClearAllCachesQuery,
} from 'Services/api/mircoservicesApi';
import { Button, Pane, toaster } from 'evergreen-ui';
import { createUseStyles } from 'react-jss';
import {
  BackendVersion,
  CalcModule,
  FrontendVersion,
  TelegramModule,
  ValidationModule,
} from './Application-version/Modules';

const useStyles = createUseStyles({
  cacheReloadButton: {
    display: 'flex',
    padding: '10px 0 0 5px',
    justifyContent: 'start',
  },
  renderBlock: {
    display: 'grid',
    alignItems: 'center',
    '& :hover': {
      background: '#f3f3f7',
    },
  },
});

const SoftwareAppVersion = () => {
  const classes = useStyles();

  const { refetch: refetchTelegramStatus, isFetching: isFetchingTelegramStatus } = useGetModuleTelegramQuery('status');
  const { refetch: refetchTelegramInfo, isFetching: isFetchingTelegramInfo } = useGetModuleTelegramQuery('info');

  const { refetch: refetchValidatorStatus, isFetching: isFetchingValidatorStatus } = useGetDVValidatorQuery('status');
  const { refetch: refetchValidatorInfo, isFetching: isFetchingValidatorInfo } = useGetDVValidatorQuery('info');

  const { refetch: refetchCalcStatus, isFetching: isFetchingCalcStatus } = useGetModuleCalcQuery('status');
  const { refetch: refetchCalcInfo, isFetching: isFetchingCalcInfo } = useGetModuleCalcQuery('info');

  const [clearAllCaches] = useLazyClearAllCachesQuery();

  const clearCache = async () => {
    try {
      await clearAllCaches();
      setTimeout(() => {
        window.location.reload();
      }, 1500);
      toaster.success('Кэш успешно сброшен');
    } catch {
      toaster.danger('Произошла ошибка при сбросе кэша');
    }
  };

  const updateStatus = () => {
    refetchValidatorStatus();
    refetchCalcStatus();
    refetchTelegramStatus();
    refetchTelegramInfo();
    refetchValidatorInfo();
    refetchCalcInfo();
  };

  const isFetching = isFetchingTelegramStatus
      || isFetchingTelegramInfo
      || isFetchingValidatorStatus
      || isFetchingValidatorInfo
      || isFetchingCalcStatus
      || isFetchingCalcInfo;

  return (
    <Pane width="max-content">
      <Pane className={classes.renderBlock}>
        <FrontendVersion />
        <BackendVersion />
        <CalcModule />
        <ValidationModule />
        <TelegramModule />
      </Pane>

      <Pane className={classes.cacheReloadButton}>
        <Button
          onClick={updateStatus}
          intent="success"
          appearance="primary"
          isLoading={isFetching}
        >
          Обновить статусы
        </Button>
      </Pane>

      <Pane className={classes.cacheReloadButton}>
        <Button
          onClick={clearCache}
          intent="danger"
          appearance="primary"
        >
          Сбросить кэш сервера
        </Button>
      </Pane>

    </Pane>
  );
};

export default SoftwareAppVersion;
